import axios from 'axios';
import RedisInfo from './RedisInfo';

const apiUrl = process.env.REACT_APP_API_URL;

const dealerShipDetails = async (lang) => {
  try {
    const responseRedisData = await RedisInfo.redisDetails();
    console.log("responseRedisData in dealerShipDetails:", responseRedisData);

    const empName = responseRedisData.EmpName; // use the correct case
    console.log("empName from redis data:", empName);

    // CRITICAL FIX: Save dealer codes in sessionStorage instead of localStorage
    // sessionStorage clears when tab closes, reducing risk of sensitive data exposure
    if (empName) {
      sessionStorage.setItem("empName", empName);
      console.log("empName saved in sessionStorage:", empName);
      sessionStorage.setItem("dealerCode", responseRedisData.DealerMapCode);
      console.log("dealerCode saved in sessionStorage:", responseRedisData.DealerMapCode);

      sessionStorage.setItem("forCode", responseRedisData.ForCode);
      console.log("forCode saved in sessionStorage:", responseRedisData.ForCode);

      sessionStorage.setItem("outletCode", responseRedisData.OutletCode);
      console.log("outletCode saved in sessionStorage:", responseRedisData.OutletCode);
      sessionStorage.setItem("locationCode", responseRedisData.LocCode);
      console.log("locationCode saved in sessionStorage:", responseRedisData.LocCode);
      sessionStorage.setItem("multiServiceDealerCode", responseRedisData.MultiServiceDealerCode);
      console.log("multiServiceDealerCode saved in sessionStorage:", responseRedisData.MultiServiceDealerCode);
    }

    return empName;
  } catch (error) {
    console.error("Error fetching details from redis for empName:", error);
    throw error;
  }
};

const saveDealerInfo = async (dealerInfo) => {
  const API_URL = `${apiUrl}/api/v1/dealerShipDetails/dealer/saveOnBoardingData`;
  console.log("dealerinfo in savedealer " + JSON.stringify(dealerInfo));

  try {
    const response = await axios.post(API_URL, {
      parentGroup: dealerInfo.userAuthenticationSuccessResponse.ParentGroup,
      dealerMapCode: dealerInfo.userAuthenticationSuccessResponse.DealerMapCode,
      locationCode: dealerInfo.userAuthenticationSuccessResponse.LocCode,
      mulSrvDealerCode: dealerInfo.userAuthenticationSuccessResponse.MultiServiceDealerCode,
      forCode: dealerInfo.userAuthenticationSuccessResponse.ForCode,
      outletCode: dealerInfo.userAuthenticationSuccessResponse.OutletCode,
      regionCode: dealerInfo.userAuthenticationSuccessResponse.RegionCode,
      dealerShipName: dealerInfo.userAuthenticationSuccessResponse.DealerName,
      massRegion: dealerInfo.userAuthenticationSuccessResponse.RegionDesc,
      massAddress: dealerInfo.DealerAddress,
      dealerState: dealerInfo.DealerState,
      dealerGstStateCode: dealerInfo.DealerGstStateCode,
      msilGstNumber: dealerInfo.MsilGstNumber,
      massCeoEmail: dealerInfo.CeoEmailId,
      massCeoMobile: dealerInfo.CeoPhone,
      massCeoName: dealerInfo.CeoName,
      massGstNumber: dealerInfo.DealerGstNumber,
      massPan: dealerInfo.DealerPanNumber
    });

    const savedData = response.data;

    // CRITICAL FIX: Store dealer info in sessionStorage instead of localStorage
    // sessionStorage clears when tab closes, reducing risk of sensitive PII exposure
    // Sensitive data (GST, PAN, CEO email) should not persist across sessions
    sessionStorage.setItem("dealerInfo", JSON.stringify(savedData));

    return savedData;
  } catch (error) {
    console.error("MASS saving dealer details failed:", error);
    
    // Check if error response contains onboarding status message
    if (error.response && error.response.data && error.response.data.creationMessage) {
      const errorMessage = error.response.data.creationMessage;
      // Throw the specific error message from backend
      throw new Error(errorMessage);
    }
    
    // Default error for other cases
    throw new Error("Invalid Credentials");
  }
};

// export both methods
const DealerShipDetails = { dealerShipDetails, saveDealerInfo };

export default DealerShipDetails;
